import MainMenuStore from '../../../../router/navigation/store/main-nav-container.store';

const getBoundsPadding = (mapDimensions: { width: number, height: number }, {
  top, left, right, bottom,
}: { top: number; right: number; bottom: number; left: number }) => {
  const verticalPadding = top + bottom;
  const horizontalPadding = left + right + MainMenuStore.width;

  // If inner (cropped) map is too small, don't apply any padding
  return {
    top: mapDimensions.height > verticalPadding ? top : 0,
    right: mapDimensions.width > horizontalPadding ? right : 0,
    bottom: mapDimensions.height > verticalPadding ? bottom : 0,
    left: mapDimensions.width > horizontalPadding ? left : 0,
  };
};

export default getBoundsPadding;
